// ---------------------------------------------------------------------------
// FC1 §A.3 — interceptor de CONTRATO (o segundo dos dois).
//
// Responsabilidade única: ser a transformação MAIS EXTERNA do erro, convertendo
// toda falha em `ApiError` antes de chegar ao `catch` da aplicação. Não
// desembrulha sucesso — isso é da camada de service (§A.4).
//
// ⚠️ ORDEM IMPORTA. O interceptor de auth (`store/modules/auth/sagas.js`)
// precisa ver o erro CRU para decidir refresh/401/403; ele é registrado no
// carregamento daquele módulo. Interceptors de resposta do axios rodam na ordem
// de registro, então este precisa ser instalado DEPOIS.
//
// Por isso a instalação é uma chamada explícita no corpo de `App.js`, e não um
// import com efeito colateral: o corpo de um módulo só executa depois que todos
// os seus imports (incluindo a store, que puxa o saga) terminaram de avaliar.
// Não trocar por `import './errors/installContractInterceptor'` — a ordem
// passaria a depender da posição da linha de import, que qualquer lint de
// ordenação pode reescrever.
// ---------------------------------------------------------------------------

import ApiError from './ApiError';

let installed = false;

export default function installContractInterceptor(client) {
   // O React remonta a árvore em StrictMode/HMR; sem a trava o mesmo
   // interceptor entraria na cadeia várias vezes.
   if (installed) return;
   installed = true;

   client.interceptors.response.use(
      (response) => response,
      (error) => Promise.reject(ApiError.fromAxiosError(error))
   );
}
